<!--
 * @Description: 
 * @Author: 诺
 * @Date: 2022-01-08 13:32:28
 * @LastEditors: 诺
 * @LastEditTime: 2022-01-08 14:15:05
-->
<template>
  <div class="total-show_wrap" :style="styleCss">
    <div class="total-show_item" v-if="sVisit == 1">
      围观人数 {{ visitTotal }}
    </div>
    <div class="total-show_item" v-if="sJoin == 1">
      参与人数 {{ joinTotal }}
    </div>
  </div>
</template>
<script>
export default {
  name: "TotalShow",
  props: {
    sJoin: [String, Number],
    sVisit: [String, Number],
    joinTotal: {
      type: [String, Number],
      default: "",
    },
    visitTotal: {
      type: [String, Number],
      default: "",
    },
    styleCss: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="stylus" scoped>
.total-show_wrap {
  display: flex;
  width: 343px;
  margin:15px auto 0;
  align-items: center;
  justify-content: space-between;
}

.total-show_item {
  box-sizing: border-box;
  width: 112px;
  height: 22px;
  color: white;
  text-align: center;
  font-size: 12px;
  font-weight: 500;
  line-height: 22px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 11px;
}
</style>
